import { useEffect } from 'react';
import { useEngineContext } from '@smartcharts/ui-web';

// Listens for SmartChart selection changes and forwards them to the coordinator
export default function SmartChartBridge() {
  const { setSymbol } = useEngineContext();

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail || {};
      const { symbol, granularity } = detail;
      console.log('[Bridge] Selection event received:', { symbol, granularity });
      try {
        if (symbol) {
          console.log('[Bridge] Calling setSymbol:', symbol, granularity ?? 0);
          setSymbol(symbol, granularity ?? 0);
        } else {
          console.warn('[Bridge] No symbol in selection event');
        }
      } catch (err) {
        console.error('[Bridge] Error forwarding selection:', err);
      }
    };
    window.addEventListener('smartchart:selection', handler as EventListener);
    return () => window.removeEventListener('smartchart:selection', handler as EventListener);
  }, [setSymbol]);

  // Nothing to render
  return null;
}
